export const colors = {
  bg: '#0a0a0f',
  bgCard: '#12121f',
  bgDark: '#080810',
  bgInput: '#1a1a2e',
  border: '#1a1a2e',
  borderLight: '#2a2a3e',
  text: '#e0e0e0',
  textMuted: '#888',
  textDim: '#666',
  textDimmer: '#444',
  accent: '#6c63ff',
  accentDark: '#4a42d4',
  green: '#00e676',
  greenDark: '#00c853',
  red: '#ff5252',
  redDark: '#d32f2f',
  orange: '#ffab40',
  yellow: '#ffd740',
  blue: '#448aff',
};

export const theme = {
  card: {
    background: colors.bgCard,
    borderRadius: 8,
    padding: 16,
    border: `1px solid ${colors.border}`,
  },
  input: {
    background: colors.bgInput,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 6,
    padding: '10px 14px',
    color: colors.text,
    fontSize: 14,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  select: {
    background: colors.bgInput,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 6,
    padding: '10px 14px',
    color: colors.text,
    fontSize: 14,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  label: {
    fontSize: 12,
    color: colors.textDim,
    marginBottom: 4,
    display: 'block',
    marginTop: 8,
  },
  btnPrimary: {
    background: `linear-gradient(135deg, ${colors.accent}, ${colors.accentDark})`,
    border: 'none',
    borderRadius: 6,
    padding: '10px 16px',
    color: '#fff',
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 13,
  },
  btnSuccess: {
    background: `linear-gradient(135deg, ${colors.green}, ${colors.greenDark})`,
    border: 'none',
    borderRadius: 6,
    padding: '10px 16px',
    color: '#000',
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 13,
  },
  btnDanger: {
    background: `linear-gradient(135deg, ${colors.red}, ${colors.redDark})`,
    border: 'none',
    borderRadius: 6,
    padding: '10px 16px',
    color: '#fff',
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 13,
  },
  btnSecondary: {
    background: colors.bgInput,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 6,
    padding: '10px 16px',
    color: colors.textMuted,
    cursor: 'pointer',
    fontSize: 13,
  },
  btnSmall: {
    padding: '6px 12px',
    fontSize: 12,
    borderRadius: 4,
    border: 'none',
    cursor: 'pointer',
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: colors.textMuted,
    marginBottom: 12,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  row: { display: 'flex', gap: 8 },
  badge: (color) => ({
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 600,
    background: color + '22',
    color: color,
  }),
};
